import type { Components } from '@mui/material';

export const MuiMenu: Components['MuiMenu'] = {
  styleOverrides: {
    paper: {
      padding: '8px',
      borderRadius: '10px',
      boxShadow: 'rgba(0, 0, 0, 0.2) 0px 5px 5px -3px, rgba(0, 0, 0, 0.14) 0px 8px 10px 1px, rgba(0, 0, 0, 0.12) 0px 3px 14px 2px',
    },
    list: {
      '& .MuiMenuItem-root': {
        padding: '6px 30px',
      },
    },
  },
};